module.exports = __webpack_public_path__ + "media/images/game_icon/vi/VGF01-b504e2246ed7fd18dc9c3131a575d906.png";